/**
 * Shared search input for the small client-side Issues lists (On Hold, Split Orders).
 *
 * Mirrors the OOS filter bar's search field (OosFilters.tsx:66-87) for visual
 * consistency — same h-12 glove-friendly height, leading Search icon, clear
 * button. Unlike OOS (which debounces to throttle a SERVER query), these lists
 * are already fully in memory, so callers filter synchronously; no debounce here.
 */
import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface IssueSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
  clearLabel: string;
}

export function IssueSearchInput({ value, onChange, placeholder, ariaLabel, clearLabel }: IssueSearchInputProps) {
  return (
    <div className="relative flex-1 min-w-[200px]">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" aria-hidden="true" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className="pl-10 pr-10 h-12"
        maxLength={100}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label={clearLabel}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
